import { Box, DatePicker, FormLabel } from '@ksyos/design-system';
import type { ValidationErrors } from '@frontend/utils';
import { getSelectedLanguage } from '@frontend/translate';
import { getValidationErrorTranslation } from '@frontend/utils';

type PeriodProps = {
    endDate?: Date;
    errors: ValidationErrors;
    onChangeDate: (name: string, value: Date | null) => void;
    onValidate: (name: string, value: Date | null) => void;
    startDate?: Date;
};

export function PeriodFilter(props: PeriodProps) {
    const language = getSelectedLanguage();

    return (
        <Box display={'flex'}>
            <Box>
                <DatePicker
                    error={getValidationErrorTranslation(props.errors.get('startDate'))}
                    onChange={(value) => handleValidationAndChange('startDate', value)}
                    value={props.startDate || null}
                />
            </Box>
            <FormLabel sx={{ margin: 2 }}>{language.common.until}</FormLabel>
            <Box>
                <DatePicker
                    error={getValidationErrorTranslation(props.errors.get('endDate'))}
                    onChange={(value) => handleValidationAndChange('endDate', value)}
                    value={props.endDate || null}
                />
            </Box>
        </Box>
    );

    function handleValidationAndChange(name: string, value: Date | null) {
        props.onChangeDate(name, value);
        props.onValidate(name, value);
    }
}
